module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/Tourists-eff718ce7beb409e7313addf775fa3c3.png";